(function() {
    'use strict';
    var TransferJobstoReedUserCtrl = function($scope, ajaxCall, xmsNotificationFactory, $uibModalInstance) {

        $scope.ngModel = {};

        $scope.fnTransferJobsPostings = function($event) {

            $event.preventDefault();
            var ajaxUrl = WEBAPP_PATH +
                "/xmsUser/processTransferJobsToReedCoUkUser?";
            var data    = $scope.ngModel;

            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    console.log("success!!! ");
                    var alertMessage = "Job Postings Transferred.";
                    xmsNotificationFactory.addObj({id: "transferPostings", type: result.data.responseType, bodyHtml: result.data.responseMessage, timeout:10});

                    $scope.cancel();
                },
                function(result) {
                    var alertMessage = "Error occurred. Please try again later.";
                    xmsNotificationFactory.addObj({id: "transferPostings", type: "danger", bodyHtml: alertMessage, timeout:10});
                    $scope.cancel();

                }
            );
            $event.preventDefault();
        };

        $scope.cancel = function(e) {
            if(angular.isDefined(e)){
                e.preventDefault();
            }
            $uibModalInstance.dismiss('cancel');
        };

    }
    TransferJobstoReedUserCtrl.$inject = ['$scope', 'ajaxCall', 'xmsNotificationFactory', '$uibModalInstance'];
    angular.module('app').controller('TransferJobstoReedUserCtrl', TransferJobstoReedUserCtrl);
}());
